// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__l5ibI","box":"Projects_box__1lYpd","item":"Projects_item__FEX1o"};